var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grey sm mb-5"},[_vm._v(_vm._s(_vm.title))]),_c('RkEcharts',{attrs:{"height":"120px","option":_vm.responseConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }